<template>
  <card>
    <b-row>
      <b-col cols="10">
        <b-form class="row" v-on:submit.prevent="doFilter">
          <b-col md="3">
            <el-input class="input-primary" placeholder="Filter By Name" clearable v-model="tableFilter.name"/>
          </b-col>
          <b-col md="1">
            <button type="submit" class="btn btn-primary"><font-awesome-icon icon="search"/> Search</button>
          </b-col>
        </b-form>
      </b-col>
      <b-col cols="2">
        <create-new-data :data-url="'/pengaturan/pengguna/kasir/create'" v-if="role === 'owner'" :clearfix="false"/>
      </b-col>
      <b-col cols="12 mb-1">
        <div class="d-flex align-items-center h-100">
          <el-checkbox v-model="fakeTableFilter.is_active">Active Only</el-checkbox>
        </div>
      </b-col>
    </b-row>
    <paginated-table ref="dataTable" :can-delete="false" :can-edit="role === 'owner'" :active-url="apiUrlUserActive" :param-no-uuid="true" :data-url="apiUrl" :data-key="dataKey" :data-columns="columns" :data-params="['is_active', 'name']">
      <template slot="content_fullName" slot-scope="defaultSlotScope">
        {{defaultSlotScope.rowData.firstName}} {{defaultSlotScope.rowData.lastName}}
      </template>
    </paginated-table>
  </card>
</template>
<script>
  import { Input, Checkbox } from 'element-ui'
  import PaginatedTable from '@/components/Tables/PaginatedTable'
  import CreateNewData from '@/components/Buttons/CreateNewData'

  export default {
    components: {
      [Input.name]: Input,
      PaginatedTable,
      CreateNewData,
      elCheckbox: Checkbox
    },
    data () {
      return {
        role: this.$store.getters['account/accountData'].roles[0].name,
        dataKey: 'profile',
        apiUrl: window.AppConfig.apiUrl + 'profile?role=kasir',
        apiUrlUserActive: window.AppConfig.apiUrl + 'profile',
        columns: [
          {
            prop: 'name',
            sortable: true
          },
          {
            prop: 'email',
            sortable: true
          },
          {
            prop: 'isActive',
            label: 'Active',
            minWidth: 20,
            isToggle: true,
            sortable: true
          }
        ],
        fakeTableFilter: {
          is_active: !!this.$route.query.is_active
        },
        tableFilter: {
          is_active: this.$route.query.is_active,
          name: this.$route.query.name
        }
      }
    },
    watch: {
      'fakeTableFilter.is_active' (value) {
        this.tableFilter.is_active = value ? 1 : null
        this.doFilter()
      }
    },
    methods: {
      doFilter () {
        this.$refs.dataTable.doFilter(this.tableFilter)
      }
    },
    mounted () {
      // this.initData().requestCategory()
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Settings/Users/Cashiers/Index.vue